import React from 'react';

// Campos de formulario de la sección Árboles, con el mismo aspecto que el
// motivo de anulación (MotivoDialog): borde input, foco primary.
export const CLASE_INPUT = 'h-10 w-full rounded-lg border border-input bg-white px-2.5 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25';
export const CLASE_AREA = 'w-full rounded-lg border border-input bg-white px-2.5 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25';

export function Campo({ label, error, ayuda, requerido, children, className = '' }) {
  return (
    <label className={`flex min-w-0 flex-col gap-1 text-sm font-medium text-foreground ${className}`}>
      <span>{label}{requerido && <span className="text-error" aria-hidden="true"> *</span>}</span>
      {children}
      {ayuda && !error && <span className="text-xs font-normal text-muted-foreground">{ayuda}</span>}
      {error && <span className="text-xs font-normal text-error">{error}</span>}
    </label>
  );
}

export function Texto({ value, onChange, area, rows = 2, ...rest }) {
  if (area) {
    return <textarea value={value} rows={rows} onChange={(e) => onChange(e.target.value)} className={CLASE_AREA} {...rest} />;
  }
  return <input value={value} onChange={(e) => onChange(e.target.value)} className={CLASE_INPUT} {...rest} />;
}
